import './FormValidationMessage.scss';

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export default class FormValidationMessage extends React.Component {
    static propTypes = {
        className: PropTypes.string
    };

    render() {
        let classes = classNames(
            'c-validation-message',
            this.props.className,
            {'is-empty': this.props.children === undefined}
        );

        return (
            <div className={classes}>
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/FormValidationMessage/index.js